import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { first } from 'rxjs';
import { ParametersService } from '../parameters/parameters.service';

@Component({
    selector: 'app-row-crop-assist',
    templateUrl: './row-crop-assist.component.html',
    styleUrls: ['./row-crop-assist.component.scss'],
    standalone: false
})
export class RowCropAssistComponent implements OnInit {

    tramlineassist: SafeResourceUrl;

    constructor(
        private readonly parametersService: ParametersService,
        private readonly sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        this.parametersService.getParametersObservable().pipe(first(params => !!params.country?.code)).subscribe(params => {
            const locale = params.country.code.split('_');
            const lang = locale[0];
            const land = locale[1];
            this.tramlineassist = this.sanitizer.bypassSecurityTrustResourceUrl(
                'https://www.poettinger.at/row-crop-assist'
                + `?lang=${lang}`
                + `&land=${land}`
                + '&embedded=true'
            );
        });
    }

}
